import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { AppSettings } from 'src/app/enums/app-settings.enum';
import { AccountService } from 'src/app/services/account.service';
import { GoogleAnalyticsService } from 'src/app/services/google-analytics.service';
import { SessionDataService } from 'src/app/services/session-data.service';
import { SkuDataService } from 'src/app/services/sku-data.service';
import { SubjectService } from 'src/app/services/subject.service';
import { UtilitiesService } from 'src/app/utilities/utilities.service';
import { environment } from 'src/environments/environment';
import { VerificationComponent } from '../verification/verification.component';
import { Location } from '@angular/common';
import { ApplicationInitializationService } from 'src/app/services/application-initialization.service';
declare var window: any;

@Component({
  selector: 'app-navigation-bar',
  templateUrl: './navigation-bar.component.html',
  styleUrls: ['./navigation-bar.component.scss']
})
export class NavigationBarComponent implements OnInit {

  @Input() label: any;
  @Input() sku: any;
  @Input() addon: any;
  @Input() isParentalControl: boolean;
  @Input() areanprosuccess:boolean;
  @Input() orderConfirmation:boolean;
  @Input() navText: string = '';
  @Output() subscribeAddon: EventEmitter<any> = new EventEmitter();

  count: any;
  public isNavCollapsed: boolean = true;
  toggleDropdown: boolean = false;
  userLoggedIn: boolean = false;
  userData: any;
  language: any = '';
  isArabic: boolean;
  ENV: any;
  currentAccount: any;
  isUserLoggedIn: boolean;
  mobileNumber: any;
  constructor(
    private AS: AccountService,
    private SS: SubjectService,
    private route: Router,
    private UTS: UtilitiesService,
    public TS: TranslateService,
    private location: Location,
    private appInitService: ApplicationInitializationService,
    private CDR: ChangeDetectorRef
  ) {
    
    if (localStorage.getItem('currentAccount')) {
      const currentAccount = JSON.parse(localStorage.getItem('currentAccount'));
      if (currentAccount) {
        this.currentAccount = currentAccount;
      }
    }
    this.SS.currentAccountNavigationBar.subscribe((r) => {
      if (r) {
        const current_user = JSON.parse(localStorage.getItem('currentAccount'));
        this.currentAccount = current_user;
        this.isUserLoggedIn = true;
        this.mobileNumber = this.currentAccount.mobileNumber
          ? this.currentAccount.mobileNumber
          : this.currentAccount.accountNo
            ? this.currentAccount.accountNo
            : '';

      }
    });
  }

  ngOnInit(): void {
    this.getUserInfo();
    this.ENV = this.UTS.getENV();
    this.language = this.UTS.getLocaleLanguage();
  }
  signIn() {
    window.location.href = environment.ECARE_URL;
  }

  
  getUserInfo() {
    this.language =
      localStorage.getItem('language') &&
      localStorage.getItem('language').toLocaleLowerCase();
    this.AS.UserInfo().subscribe(
      (r: any) => {
        if (r) {
          this.userData = r;
          this.userLoggedIn = true;
          this.CDR.detectChanges();
        }
      },
      () => {
        this.userLoggedIn = false;
        this.CDR.detectChanges();
      }
    );
  }

  changeLangAction() {
    const lang = localStorage.getItem('language');
    if (lang.toLocaleLowerCase() == 'en') {
      localStorage.setItem('language', 'ar');
      this.TS.setDefaultLang('ar');
      const url =
        window.location.href.split('?') && window.location.href.split('?')[0]
          ? window.location.href.split('?')[0] +
            '?skuId=' +
            this.sku.skuId +
            '&lang=ar'
          : window.location.href.split('?')[0] + '?lang=ar';

      window.location.href = url;
    }
    if (lang.toLocaleLowerCase() == 'ar') {
      localStorage.setItem('language', 'en');
      this.TS.setDefaultLang('en');
      const url =
        window.location.href.split('?') && window.location.href.split('?')[0]
          ? window.location.href.split('?')[0] +
            '?skuId=' +
            this.sku.skuId +
            '&lang=en'
          : window.location.href.split('?')[0] + '?lang=en';

      window.location.href = url;
    }
  }

  logOut() {
    this.AS.logOut().subscribe((res) => {
      this.signIn();
    });
  }

  trackOrder() {
    window.location.href = environment.BASE_URL + '/userOrdersTracking';
  }

  goToCart() {
    const OS = this.UTS.getMobileOperatingSystem();
    if (this.ENV == 'mobile' && OS == 'Android') {
      window.deals.goToCartScreen();
    } else if (this.ENV == 'mobile' && OS == 'iOS') {
      (window as any).webkit.messageHandlers.hybridInterface.postMessage(
        'cart'
      );
    }
  }

  back() {
    const OS = this.UTS.getMobileOperatingSystem();
    if (
      this.ENV === 'mobile' &&
      this.UTS.getNavigationSource() &&
      this.UTS.getNavigationSource() === 'parentalControl'
    ) {
      if (OS === 'Android') {
        window.ParentalControl.goBackScreen(this.UTS.getNavigationSource());
      } else if (OS === 'iOS') {
        const messgeToPost = {
          method: 'goBackScreen',
          payload: this.UTS.getNavigationSource(),
        };
        (window as any).webkit.messageHandlers.hybridInterface.postMessage(
          JSON.stringify(messgeToPost)
        );
      }
    } else {
      if (this.isParentalControl) {
        const CAT = localStorage.getItem('CAT')
          ? localStorage.getItem('CAT')
          : this.appInitService.environmentConfig?.PARENTAL_CONTROL_ADDONS;
        this.route.navigateByUrl(
          `/parentalControlAddons?subCategory=${CAT}&lang=${this.UTS.getLocaleLanguage().toLocaleLowerCase()}`
        );
      } else if (
        localStorage.getItem('isRoaming') !== null &&
        localStorage.getItem('isRoaming') == 'true'
      ) {
        this.location.back();
      } else {
        this.location.back();
        // const CAT = localStorage.getItem('CAT')
        //   ? localStorage.getItem('CAT')
        //   : AppSettings.POSTPAID;
        // const subCategoryId = localStorage.getItem('subCategoryId');
        // const url =
        //   '/addons?subCategory=' +
        //   CAT +
        //   '&categoryDimension=' +
        //   subCategoryId +
        //   '&lang=' +
        //   this.UTS.getLocaleLanguage();
        // this.route.navigateByUrl(url);
      }
    }
  }

  format(data: any) {
    return data ? this.UTS.format(data) : data;
  }

  
}